import * as Adaptive from "adaptivecards";
import { TypedCardElementPeer, PropertySheet, PropertySheetCategory } from "adaptivecards-designer";
import { getPropertyEditorInstance, PropertyKeys } from "../Pickers/PickerBase";
import { removeOtherPropertyConfigurations } from "../Utils/CustomElementUtils";

const displayLabelProperty = new Adaptive.StringProperty(Adaptive.Versions.v1_0, "displayLabel", true);
const requireFieldProperty = new Adaptive.BoolProperty(Adaptive.Versions.v1_0, "requireField", false);

export class DueDate extends Adaptive.DateInput {
    static readonly JsonTypeName = "Due Date";
    static readonly ElementId = "Ticket.DueDate";
    static readonly defaultLabel = "Due Date";
    static readonly displayLabelProperty = displayLabelProperty;
    static readonly requireFieldProperty = requireFieldProperty;

    //#region Schema

    @Adaptive.property(displayLabelProperty)
    get displayLabel(): string | undefined {
        return this.getValue(DueDate.displayLabelProperty);
    }

    set displayLabel(value: string | undefined) {
        this.setValue(DueDate.displayLabelProperty, value);
        this.updateLayout();
    }

    @Adaptive.property(requireFieldProperty)
    get requireField(): boolean | undefined {
        return this.getValue(DueDate.requireFieldProperty);
    }

    set requireField(value: boolean | undefined) {
        this.setValue(DueDate.requireFieldProperty, value);
        this.updateLayout();
    }

    //#endregion

    protected internalRender(): HTMLElement | undefined {
        this.id = DueDate.ElementId;
        if((this?.displayLabel ?? "").length == 0)
            this.displayLabel = DueDate.defaultLabel;

        let textInput = new Adaptive.DateInput();
        textInput.setParent(this);
        textInput.label = this.displayLabel;
        textInput.isRequired = this.requireField;

        if(this.defaultValue)
            textInput.defaultValue = this.defaultValue;

        const renderedElement =  textInput.render();
        this.inputControlContainerElement.style.display = "block";

        return renderedElement;
    }

    getJsonTypeName(): string {
        return DueDate.JsonTypeName;
    }

    updateLayout(processChildren: boolean = true) {
        super.updateLayout(processChildren);
    }
}

export class DueDatePeer extends TypedCardElementPeer<DueDate> {
    static displayLabelProperty = getPropertyEditorInstance(DueDate.ElementId, PropertyKeys.displayLabel);
    static requireFieldProperty = getPropertyEditorInstance(DueDate.ElementId, PropertyKeys.requireField);
         
    populatePropertySheet(propertySheet: PropertySheet, defaultCategory: string = PropertySheetCategory.DefaultCategory) {
        super.populatePropertySheet(propertySheet, defaultCategory);
        removeOtherPropertyConfigurations(propertySheet);
                
        propertySheet.add(
            defaultCategory,
            DueDatePeer.idProperty,
            DueDatePeer.displayLabelProperty,
            DueDatePeer.requireFieldProperty
        );
    }
}